import { AxiosError } from 'axios';

const isAxiosError = (err: unknown): err is AxiosError => {
  return Boolean(err && (err as AxiosError).isAxiosError);
};

export default isAxiosError;
